module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/redux-act-async/~/core-js/library/modules/_library.js
// module id = 2012
// module chunks = 0